<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-md-2 "></div>
            <div class="col-md-10 ">
                <div class="header-block">
                    <h2>{{"HOME.about-us.title" | translate}}</h2>
                    <p>
                        {{'HOME.about-us.text' | translate}}
                    </p>
                </div>
            </div>
        </div>
        <app-about-us-item [item]="item" *ngFor="let item of items"></app-about-us-item>
    </div>
</section>
